import {AddRealmRoute} from "./routes/AddRealm.js";
const routes = [AddRealmRoute];
export default routes;
